module.exports = __webpack_public_path__ + "img/oskar-rainbow-plain.036de5a9.svg";